module.exports = __webpack_public_path__ + "img/01.c4d3973c.jpg";